const MC_APPOINTMENT = 'mcAppointment';
const MC_CONTACT_US = 'mcContactUs';
const ADA_CONTACT_US = 'adaContactUs';
const MC_CONTACT_US_SEARCH = 'search';

export { MC_APPOINTMENT, MC_CONTACT_US, ADA_CONTACT_US, MC_CONTACT_US_SEARCH };
